import React, { useState, useEffect, useContext } from 'react';
import Modal from "react-modal";
import axios from "axios";
import { getwayApi } from '../../../config/Constants';
import './styles/SummaryModal.scss';
// import {SectionHeader} from '../../components/sectionHeader/sectionHeader'
// import { testFormSpec } from '../../../context/formSpec_patient';
import Button from '../../components/Button/Button';
import { BackArrowIcon, Icon_BulletPoint, Icon_PBV, Icon_Warning, Icon_MedicalRecord, Icon_DropdownArrow, Icon_MedicalFacility, Icon_Doctor } from '../form/styles/assets/icons';
import { LogoAndTitle } from '../form/sections/LogoAndTitle_Section/LogoAndTitle';
import { object } from 'prop-types';
import { resetFormLists, doctorList, sensitiveInfoDisclosures, sensitiveInfoToggle, consoleLogs, convertSubmissionObject } from './logic';
import './summaryModal.scss';
import { CloseIcon } from '../form/styles/assets/icons';
import { ConfigContext } from '../form/DynamicForm/DynamicForm';

export const SummaryModal2 = ({ config, submitData, isModelOpen, setSummary, logo, formId, formik, testFormSpec, setNextPage, formType, sensitiveInfoOrg }) => {
    const [closeModal, setCloseModal] = useState(isModelOpen);
    const [sensitiveInfoDropped, setSensitiveInfoDropped] = useState(false);

    const { dbFormSpec } = useContext(ConfigContext);

    const userInput = formik.values;

    // document.getElementsByTagName('body')[0].style.overflow = 'hidden'

    const submitForm = async () => {
        convertSubmissionObject(formik, dbFormSpec.facility.orgId, outPatientSummaryList).then((value) => {
            setNextPage(true);
            submitData(value);
        })
    }

    useEffect(() => {
        dbFormSpec.facility.orgId.includes('7307') ? console.log('') : formik.setFieldValue('pdf_facilitiesList', formik.values.facilityList.join(',  '))
    }, [formik.values.facilityList])
    // REFACTOR TO ADD THIS TO SELECTANDTYPE COMPONENT

    useEffect(() => {
        userInput.PPhone === '' && formik.setFieldValue('PPhone', 'No Phone Provided')
        if (userInput.PPhone === 'No Phone Provided') {
            return () => { formik.setFieldValue('PPhone', '') }
        }
    }, [formik.values.PPhone])

    useEffect(() => {
        userInput.PEmail === '' && formik.setFieldValue('PEmail', 'No Email Provided')
        if (userInput.PEmail === 'No Email Provided') {
            return () => { formik.setFieldValue('PEmail', '') }
        }
    }, [formik.values.PEmail, formik.values.PPhone])

    const resetFormLists = () => {
        let values = userInput
        for (let property in values) {
            if (property.includes('requesteditem') || property.includes('inputAuthorizeFacility') || property.includes('exclude')) {
                delete values[property];
            }
        }
        // formik.setValues({...values, test: 'test'})
        formik.values.inputPhysicianNames !== 'not_applicable' && formik.setFieldValue('inputPhysicianNames', "")
        // Clear the names stored on inputPhysicianName in case user makes new selections on resubmit
        // formik.setFieldValue('txtotherrecords', "")
        // Clear the names stored on txtotherrecords in case user makes new selections on resubmit
    }

    const ui = userInput

    const patientInputObj = {
        sectionTitle: 'Patient Information',
        values: {
            name: `${ui.PFName} ${ui.PMName} ${ui.PLName}`,
            phone: ui.PPhone,
            email: ui.PEmail,
            date_of_birth: ui.PDOB,
            patient_address: `${ui.PAddress1} ${ui.PAddress2} ${ui.PCity}, ${ui.PState} ${ui.PZip}`,
            maiden_or_other_name: ui.POName
        }
    }

    const repInputObj = {
        sectionTitle: 'Representative Information',
        values: {
            name: `${ui.RepFName} ${ui.RepMName} ${ui.RepLName}`,
            phone: ui.RepPhone,
            email: ui.RepEmail,
            relationship_to_patient: ui.rrelationship,
            address: `${ui.RepAddress1} ${ui.RepAddress2} ${ui.RepCity}, ${ui.RepState} ${ui.RepZip}`
        }
    }
    const deliveryInputObj = {
        sectionTitle: 'Delivery of Records',
        values: {
            recipient_name: ui.RName,
            recipient_phone: ui.RPhone,
            recipient_email: ui.REmail,
            recipient_fax: ui.RFax,
            recipient_address: ui.pdf_RAddress,
            delivery_method: ui.pdf_deliveryMethod,
        }
    }

    //Filter out the entries with empty text
    const filteredLog = Object.keys(ui).reduce((newObj, key) => {
        if ((ui[key]) && ui[key] !== "") {
            newObj[key] = ui[key];
        }
        return newObj;
    }, {});


    //Populate the facility list for the summary page and the fax.
    const outPatientSummaryList = `${Object.keys(filteredLog).filter((key) => { return key.includes('CustomTextbox_') }).map((key) => { return `${key.replace('CustomTextbox_', '')}: ${filteredLog[key]}` }).join('   |   ')}`



    const orgId = dbFormSpec.facility.orgId;
    // const triPartiteOrg = orgId.includes('7042') || orgId.includes ('7101') || orgId.includes('7239')

    const recordsInputObj = {
        sectionTitle: 'Medical Records',
        values: {
            medical_records_released: ui.pdf_releaseItemsList,
            sensitive_info_released: sensitiveInfoOrg ? ui.pdf_sensitiveInfoList : null,
            dates_of_service: ui.pdf_serviceDates,
            facilities_releasing_info: ui.pdf_facilitiesList,
            other_facilities: ui.facilityOther,
            outpatient_facilities: outPatientSummaryList,
            request_purpose: ui.disclosurePurposeGroup,
            additional_information: ui.OtherNote
        }
    }


    return (
        <div className="summary-modal">
            {/* <div
                id='summary-back-button'
                className="summary-button back-button"
                onClick={() => { setCloseModal(false); setSummary(false); resetFormLists(); }}
            >
                <div className="back-text">
                    <BackArrowIcon />
                    {'Back to Form'}
                </div>
            </div> */}



            <div className='summary-content'>
                <div className="header">
                    <LogoAndTitle formId={formId} titleText={'Request Summary'} titleColor={'#717275'} dbFormSpec={config} />
                    <div className='close-link' onClick={() => { setCloseModal(false); setSummary(false); resetFormLists(); }}>
                        <p className="link-text">Back to Form</p>
                        <CloseIcon color={'black'} />
                    </div>
                </div>

                <div id="summary-sections">

                    <div className='wrapping-sec-container'>
                        <WrappingSec config={config} sectionInputs={patientInputObj} />
                        {formType === 'Representative' && <WrappingSec config={config} sectionInputs={repInputObj} />}
                        <WrappingSec config={config} sectionInputs={deliveryInputObj} />
                    </div>
                    <div className='summary-sec'>
                        <h5 style={{ color: config.color }}>{recordsInputObj.sectionTitle}</h5>
                        {Object.entries(recordsInputObj.values).map((valuePair) => {
                            if (valuePair[1]) {
                                return (
                                    <div className="value-pair">
                                        <p className="overline">{valuePair[0].replaceAll('_', ' ')}</p>
                                        <p className="body1">{valuePair[1]}</p>
                                    </div>
                                )
                            }
                            else { return null }
                        })}
                    </div>

                </div>

                <div id='summary-buttons'>
                    <p className='statement' style={{ marginBottom: 19 }}>
                        BY CLICKING SUBMIT REQUEST, I hereby certify that the information I have provided is true and accurate to the best of my knowledge. I acknowledge that this authorization is legally binding and that I am the patient, or representative for the patient, whose health information is being requested.  I certify that any deliberate misrepresentation or omission may result in legal consequences. I understand and agree that this disclosure and the protected health information that may be disclosed as described in this authorization is subject to the rules and regulations established by the Health Insurance Portability and Accountability Act (HIPAA).
                        {/* <br/>
                        <br/>
                        If a fee does apply, you will be notified before your request is processed. */}
                    </p>

                    <Button label={'Submit Request'} type='submit' onClick={
                        () => {
                            //  formik.values.sensitiveInfo.forEach((item) => {
                            //      formik.values = { ...formik.values, [item]: 'on' }
                            //  })

                            // delete formik.values.sensitiveInfo;
                            formik.values.infoToReleaseGroup.forEach((item) => {
                                formik.values = { ...formik.values, [item]: 'on' }
                            })
                            // delete formik.values.infoToReleaseGroup
                            // convertSubmissionObject(formik);
                            // setNextPage(true);
                            // submitData(userInput);
                            submitForm();
                        }
                    } style={{ backgroundColor: testFormSpec.color }} classes={'submit-button'} />
                </div>
                <div id="summary-dates">
                    <p className='statement' style={{ marginBottom: 19 }}>
                        Today's date: <b>{userInput.RequestDate}</b>  Form Expiration date:  <b>{userInput.expirationdate}</b>.
                    </p>
                </div>
                <Icon_PBV />
            </div>
        </div>
    )

}



const WrappingSec = ({ sectionInputs, config }) => {
    return (
        <div className='summary-sec wrapping-sec'>
            <h5 style={{ color: config.color }}>{sectionInputs.sectionTitle}</h5>
            <div className='sec-columns'>
                <div className='column'>
                    {Object.entries(sectionInputs.values).map((valuePair, index) => {
                        if (index < 3 && valuePair[1] && !valuePair[1].includes('undefined')) {
                            return (
                                <div className="value-pair">
                                    <p className="overline">{valuePair[0].replaceAll('_', ' ')}</p>
                                    <p className="body1">{valuePair[1]}</p>
                                </div>
                            )
                        }
                    })}
                </div>
                <div className='column'>
                    {Object.entries(sectionInputs.values).map((valuePair, index) => {
                        if (index >= 3 && valuePair[1] && !valuePair[1].includes('undefined')) {
                            return (
                                <div className="value-pair">
                                    <p className="overline">{valuePair[0].replaceAll('_', ' ')}</p>
                                    <p className="body1">{valuePair[1]}</p>
                                </div>
                            )
                        }
                    })}
                </div>
            </div>

        </div>
    )
}



